import React from "react";
import { MediaPlayButton } from "media-chrome/react";
import { PauseIcon, PlayIcon } from "assets";
import "./styles.scss";

const SIZE = 20;

const PlayButton = () => {
  return (
    <MediaPlayButton className="play-button bg-transparent p-0">
      <span slot="play">
        <PlayIcon width={SIZE} height={SIZE} />
      </span>
      <span slot="pause">
        <PauseIcon width={SIZE} height={SIZE} />
      </span>
    </MediaPlayButton>
  );
};

export default PlayButton;
